import { GridItemType } from "components/Chakra/Card/CardMotion";
import { IPhoto } from "utils/offer";
import Card from "../Card";
import PhotoCard from "../PhotoCard";

const itemsGallery: Array<IPhoto> = [
  {
    path: "/img/scenes/Matterport/tab-1-1.png",
    id: 111,
  },
  {
    path: "/img/scenes/Matterport/tab-1-2.png",
    id: 222,
  },
  {
    path: "/img/scenes/Matterport/tab-1-3.png",
    id: 333,
  },
  {
    path: "/img/scenes/Matterport/tab-1-4.png",
    id: 444,
  },
];

export const firstTabItems: Array<GridItemType> = [
  {
    content: (
      <Card
        title="Fotogalerie je první věc, kterou váš potencionální zákazník uvidí"
        subTitle="Proto je musí ihned zaujmout. Náš zkušený fotograf vámi poradí, jak bude vaše nemovitost na fotkách co nejlépe vypadat. Prohlédněte si ukázky."
      />
    ),
    gridItemSetting: { name: "A", h: { base: "224px", md: "267px" } },
    isGalerryIcon: false,
    filterBrightnessPercent: 60,
  },
  {
    content: <PhotoCard itemsGallery={itemsGallery} id={itemsGallery[0].id} />,
    gridItemSetting: { name: "B", h: { base: "200px", md: "555px" } },
    filterBrightnessPercent: 60,
  },
  {
    content: <PhotoCard itemsGallery={itemsGallery} id={itemsGallery[1].id} />,
    gridItemSetting: { name: "C", h: { base: "200px", md: "267px" } },
    filterBrightnessPercent: 60,
  },
  {
    content: <PhotoCard itemsGallery={itemsGallery} id={itemsGallery[2].id} />,
    gridItemSetting: { name: "D", h: { base: "200px", md: "555px" } },
    filterBrightnessPercent: 60,
  },
  {
    content: <PhotoCard itemsGallery={itemsGallery} id={itemsGallery[3].id} />,
    gridItemSetting: { name: "E", h: { base: "200px", md: "555px" } },
    filterBrightnessPercent: 60,
  },
];
